import { PIOversightStatus } from '../../../types/pi_oversight.types';
export const getStatusBadgeVariant = (status) => {
    switch (status) {
        case PIOversightStatus.OVERDUE:
            return 'danger';
        case PIOversightStatus.REVIEW_REQUIRED:
            return 'incomplete';
        case PIOversightStatus.CURRENT:
            return 'common';
        default:
            return 'common';
    }
};
